var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.939 18H5.06005C3.71986 17.9997 2.4345 17.4679 1.48591 16.5212C0.537318 15.5745 0.00295862 14.2902 4.57764e-05 12.95L4.57764e-05 5.05C0.00295862 3.70982 0.537318 2.42551 1.48591 1.47879C2.4345 0.532079 3.71986 0.000261641 5.06005 0L14.939 0C16.2809 0.00256781 17.5675 0.534819 18.519 1.481C18.9898 1.9483 19.3631 2.50439 19.6173 3.11704C19.8715 3.72969 20.0016 4.3867 20 5.05V12.95C19.9971 14.2904 19.4626 15.5748 18.5138 16.5216C17.565 17.4683 16.2794 18 14.939 18ZM4.03405 5.246C3.93449 5.24511 3.8358 5.26452 3.74399 5.30303C3.65218 5.34154 3.56918 5.39835 3.50005 5.47C3.36964 5.60012 3.29064 5.77297 3.27759 5.95673C3.26454 6.14048 3.31833 6.32276 3.42905 6.47L3.56005 6.6L8.11005 10.15C8.66436 10.5908 9.35182 10.8305 10.06 10.83C10.7703 10.8284 11.4596 10.589 12.018 10.15L16.53 6.54L16.61 6.46C16.7267 6.31883 16.7894 6.14089 16.7872 5.9578C16.785 5.77471 16.718 5.59833 16.598 5.46C16.4597 5.31182 16.2719 5.21935 16.07 5.2H16.028C15.836 5.19869 15.6506 5.27015 15.509 5.4L11 9C10.7189 9.23298 10.3652 9.36033 10 9.36C9.63531 9.3581 9.2823 9.23101 9.00005 9L4.50005 5.4C4.3654 5.29973 4.20193 5.24571 4.03405 5.246Z",
    fill: "#0D0F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.dd97dc51f18015c8a217627a8bdd1ec3.svg";
export { ForwardRef as ReactComponent };